import Button from 'material-ui/Button'
import Grid from 'material-ui/Grid'
import Typography from 'material-ui/Typography'
import withStyles from 'material-ui/styles/withStyles'
import React from 'react'
import styleSheet from './AllWebChatStyle.style'

class WebChatSend extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      message: '',
      imageUri: null,
    }
  }

  messageChange(e) {
    this.setState({ message: e.target.value })
  }

  imageUriChange(e) {
    const file = e.target.files[0] || e.dataTransfer.files
    this.setState({ imageUri: file })
  }

  onSendMessage(message = null, imageUri = null) {
    if (message) this.props.sendMessage(message, null)
    if (imageUri) this.props.sendMessage('[添付画像]', imageUri)
    this.setState({ message: '' })
    this.setState({ imageUri: null })
    this.imageUri.value = null
  }

  render() {
    const { message } = this.state
    const { imageUri } = this.state
    const classes = this.props.classes
    const { can_attach_picture } = this.props
    const maxLength = 300
    const isDisabled = message.length > maxLength
    const characterCountStyle = {
      color: isDisabled ? 'red' : 'black',
      textAlign: 'right',
    }
    const buttonStyle = isDisabled ? { backgroundColor: `grey` } : {}

    let file_attach_area
    if (can_attach_picture == true) {
      file_attach_area = (
        <Grid item xs={12}>
          <input
            type="file"
            onChange={(e) => this.imageUriChange(e)}
            ref={(ref) => (this.imageUri = ref)}
            id="file-input-field"
            className={classes.input}
            style={{ display: 'none' }}
          />
          <label htmlFor="file-input-field">
            <Button variant="contained" component="span" className={classes.chatSend_fileAttachButton}>
              画像を添付する
            </Button>
          </label>

          {!!this.state.imageUri ?
            <span> {this.state.imageUri.name} </span>
          : null}
        </Grid>
      )
    } else {
      file_attach_area = null
    }

    return (
      <Grid container spacing={8} className={classes.chatSend_container}>
        <Grid item xs={10} style={{ padding: '0px' }}>
          <textarea
            className={classes.chatSend_textArea}
            value={message}
            onChange={(e) => this.messageChange(e)}
            rows="4"
            type="text"
            placeholder="メッセージを入力"
          />
        </Grid>

        <Grid item xs={2} className={classes.chatSend_submit}>
          <button
            className={classes.chatSend_button}
            onClick={() => this.onSendMessage(message, imageUri)}
            disabled={isDisabled}
            style={buttonStyle}
          >
            <Typography className={`mplus-bold ${classes.textWhite}`}>
              <b>送信</b>
            </Typography>
          </button>
        </Grid>
        <Grid item xs={10} style={{ display: 'flex', padding: '0px 0px 5px' }}>
          <Grid item xs={11}>
            <div style={{ color: 'grey' }}>
              相談内容をご送信ください。
              <br />
              例：ご年齢、いつから、どこが、どのように
              <br />
              　　健診結果の場合は項目や数値・自覚症状の有無・これまでの変化
            </div>
          </Grid>
          <Grid item xs={1}>
            <div style={characterCountStyle}>
              {message.length}/{maxLength}
            </div>
          </Grid>
        </Grid>
        {file_attach_area}
      </Grid>
    )
  }
}

export default withStyles(styleSheet)(WebChatSend)
